import * as React from "react";
import { RadioGroup as RadioGroupPrimitive } from "radix-ui";
import { Circle } from "@/components/icons";

import { cn } from "@/lib/utils";

function RadioGroup({
  ref,
  className,
  orientation,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      orientation={orientation}
      className={cn(orientation === "horizontal" ? "flex flex-wrap items-center gap-x-6 gap-y-2" : "grid gap-2", className)}
      {...props}
      ref={ref}
    />
  );
}

function RadioGroupItem({
  ref,
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "relative aspect-square h-4 w-4 rounded-full max-md:after:absolute max-md:after:-inset-3.5 max-md:after:content-[''] border border-input bg-card text-action-fill ring-offset-background focus:outline-none focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-action-fill",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <Circle className="h-2.5 w-2.5 fill-current text-current" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
